import { IField } from "../interfaces/Field"

export const previusTaskDepencency: IField[] = [
    { name: "ALL_IMMEDIATE", value: "AND (all task should complete)" },
    { name: "ANY_IMMEDIATE", value: "OR (only 1 task should complete)" },
    { name: "ALL_ACTIVATED", value: "AND - ACTIVATED ONLY" },
    { name: "ANY_ACTIVATED", value: "OR - ACTIVATED ONLY" },
]

export const nextTaskType: IField[] = [
    { name: "ALL", value: "ALL (all task should trigger)" },
    { name: "PROBABILITY", value: "PROBABILITY (only 1 task should trigger with probability)" },
    { name: "NONE", value: "NONE (there is no next task)" },
]
